export default {
  DJToJS: {
    /**
     * @typedef {Object} ShortSkillDJ
     * @property {Number} id - ID de la compétence associée
     * @property {String} name - Nom de la compétence associée
     * @property {Boolean} weight - Pondération de l'association avec la compétence
     */
    /**
     * @typedef {Object} LikertQuestionDJ
     * @property {Number} id - ID de la question
     * @property {String} label - Label de la question
     * @property {Boolean} is_active - État d'activation de la question
     * @property {String} question_type - Type de la question
     * @property {String} created_at - Date de création de la question
     * @property {String} updated_at - Date de dernière modification de la question
     * @property {String} definition - Champ JSON stringifié contenant la définition de la question
     * @property {ScaleDJ} likert_scale - échelle de Likert associée
     * @property {ShortSkillDJ[]} skills - Compétences associées
     * @property {String} repository - ID du référentiel de ses compétences
     *
     * @param questionDJ {LikertQuestionDJ}
     * @return {LikertQuestionAir}
     */
    likert (questionDJ) {
      let definition = JSON.parse(questionDJ.definition)

      return {
        id: questionDJ.id,
        label: questionDJ.label,
        text: definition.question,
        isActive: questionDJ.is_active,
        // createdAt: Date.parse(questionDJ.created_at),
        updatedAt: Date.parse(questionDJ.updated_at),
        type: questionDJ.question_type,
        selectedBySkill: false,
        scale: Object.assign(
          this.likertScale(questionDJ.likert_scale),
          { inverted: definition.scaleInverted }
        ),
        skills: questionDJ.skills,
        repositoryID: questionDJ.repository,
        skillsNumber: questionDJ.skills.length
      }
    },
    /**
     * @typedef {Object} MCQQuestionDJ
     * @property {Number} id - ID de la question
     * @property {String} label - Label de la question
     * @property {Boolean} is_active - État d'activation de la question
     * @property {String} question_type - Type de la question
     * @property {String} created_at - Date de création de la question
     * @property {String} updated_at - Date de dernière modification de la question
     * @property {String} definition - Champ JSON stringifié contenant la définition de la question
     *
     * @param questionDJ {MCQQuestionDJ}
     * @return {MCQQuestionAir}
     */
    mcq (questionDJ) {
      let definition = JSON.parse(questionDJ.definition)

      return {
        id: questionDJ.id,
        label: questionDJ.label,
        text: definition.question,
        isActive: questionDJ.is_active,
        // createdAt: Date.parse(questionDJ.created_at),
        updatedAt: Date.parse(questionDJ.updated_at),
        type: questionDJ.question_type,
        required: definition.required,
        isUnique: definition.isUnique,
        responses: definition.responses
      }
    },
    /**
     * @typedef {Object} OpenQuestionDJ
     * @property {Number} id - ID de la question
     * @property {String} label - Label de la question
     * @property {Boolean} is_active - État d'activation de la question
     * @property {String} question_type - Type de la question
     * @property {String} created_at - Date de création de la question
     * @property {String} updated_at - Date de dernière modification de la question
     * @property {String} definition - Champ JSON stringifié contenant la définition de la question
     *
     * @param questionDJ {OpenQuestionDJ}
     * @return {OpenQuestionAir}
     */
    open (questionDJ) {
      let definition = JSON.parse(questionDJ.definition)

      return {
        id: questionDJ.id,
        label: questionDJ.label,
        text: definition.question,
        isActive: questionDJ.is_active,
        // createdAt: Date.parse(questionDJ.created_at),
        updatedAt: Date.parse(questionDJ.updated_at),
        type: questionDJ.question_type,
        required: definition.required,
        isLong: definition.isLong
      }
    },
    /**
     * @typedef {Object} ScaleDJ
     * @property {Number} id - ID de l'échelle
     * @property {String} label - Label de la de l'échelle
     * @property {Boolean} is_active - État d'activation de l'échelle
     * @property {Date} updated_at - Date de dernière modification de l'échelle
     * @property {String} max_label - Étiquette haute de l'échelle
     * @property {Number} min_label - Étiquette basse de l'échelle
     *
     * @param {ScaleDJ} scaleDJ
     * @param {Boolean} fullDefinition
     * @return {ScaleAir}
     */
    likertScale (scaleDJ, fullDefinition = false) {
      return {
        id: scaleDJ.id,
        // updatedAt: scaleDJ.updated_at,
        maxLabel: scaleDJ.max_label,
        minLabel: scaleDJ.min_label,
        ...fullDefinition
          ? {
            label: scaleDJ.label,
            isActive: scaleDJ.is_active
          } : {}
      }
    }
  },
  JSToDJ: {
    /**
     * @typedef {LikertQuestionDJ|MCQQuestionDJ|OpenQuestionDJ} QuestionDJ
     */
    /**
     * @param questionJS {LikertQuestionAir}
     * @return {LikertQuestionDJ}
     */
    likert (questionJS) {
      return {
        // id: questionJS.id,
        label: questionJS.label,
        is_active: questionJS.isActive,
        question_type: questionJS.type,
        // created_at: questionJS.createdAt,
        // updated_at: questionJS.updatedAt,
        definition: JSON.stringify({
          question: questionJS.text,
          scaleInverted: questionJS.scale.inverted
        }),
        likert_scale: questionJS.scale.id,
        skills: questionJS.skills
      }
    },
    /**
     * @param questionJS {MCQQuestionAir}
     * @return {MCQQuestionDJ}
     */
    mcq (questionJS) {
      questionJS.responses = questionJS.responses.filter(response => response.text !== '')

      return {
        // id: questionJS.id,
        label: questionJS.label,
        is_active: questionJS.isActive,
        question_type: questionJS.type,
        // created_at: questionJS.createdAt,
        // updated_at: questionJS.updatedAt,
        definition: JSON.stringify({
          question: questionJS.text,
          required: questionJS.required,
          isUnique: questionJS.isUnique,
          responses: questionJS.responses
        })
      }
    },
    /**
     * @param questionJS {OpenQuestionAir}
     * @return {OpenQuestionDJ}
     */
    open (questionJS) {
      return {
        // id: questionJS.id,
        label: questionJS.label,
        is_active: questionJS.isActive,
        question_type: questionJS.type,
        // created_at: questionJS.createdAt,
        // updated_at: questionJS.updatedAt,
        definition: JSON.stringify({
          question: questionJS.text,
          isLong: questionJS.isLong,
          required: questionJS.required
        })
      }
    }
  }
}
